import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=093d439e&scoped=true&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=093d439e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d439e",
  null
  
)

export default component.exports